import './MuteButton.css'

interface MuteButtonProps {
  muted: boolean
  onToggle: () => void
  label: string
  size?: 'sm' | 'md'
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export function MuteButton({ muted, onToggle, label, size = 'md', onClick }: MuteButtonProps) {
  return (
    <button
      type="button"
      className={`mute-btn mute-btn-${size} ${muted ? 'is-muted' : ''}`}
      onClick={(e) => {
        onClick?.(e)
        if (e.defaultPrevented) return
        onToggle()
      }}
      aria-label={muted ? `Unmute ${label}` : `Mute ${label}`}
      aria-pressed={muted}
    >
      <span aria-hidden="true">{muted ? '🔇' : '🔊'}</span>
    </button>
  )
}
